export default __webpack_public_path__ + "static/media/logo.9901a8a0.svg";